import { IBeneficiary } from 'settings';

export interface IBeneficiaryCard {
  beneficiary: IBeneficiary;
  onClick?: () => void;
  checkedBeneficiary?: string;
}

export enum EBeneficiaryStatus {
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}
